import { post, get } from 'src/lib/http';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';
import useSWR, { mutate } from 'swr';

interface Response<T> {
  code: number;
  msg: string;
  err_detail: string;
  data: T;
}

export interface RegisterDetailData {
  event_id: string;
  host_id: string;
  content: string;
  is_default: boolean;
  picture_list: Array<{
    cos_key: string;
    cos_url: string;
    dataUrl?: string;
  }>;
  default_picture: {
    cos_key: string;
    cos_url: string;
  };
  /** 定制方式，0-默认，1-canvas模式	*/
  custom_mode: number;
}

export interface RegisterSaveParams {
  content: string;
  picture: Array<string>;
  event_id: string;
  /** 定制方式 0-默认，1-canvas模式	 */
  custom_mode: 0 | 1;
}

// 报名配置项-详情
export const getRegisterDetail = (event_id: string, content_image_type?: string) => {
  const path = '/v2/activities/dashboard/register/detail';
  if (!event_id) return Promise.resolve(undefined);
  return get<Response<RegisterDetailData>>(HttpPrefix.WEMEET_TAPI, path, {
    event_id,
    content_image_type,
  }).then((res) => {
    if (res.code !== 0) return Promise.reject(res.msg || res.err_detail);
    return res.data;
  });
};

// 详情swr
export const useRegisterDetail = (event_id: string, content_image_type?: string) =>
  useSWR(
    () => (event_id ? `/v2/activities/dashboard/register/detail/${event_id}` : false),
    () => getRegisterDetail(event_id, content_image_type),
    {
      revalidateOnFocus: false,
    },
  );

export const updateRegisterDetail = (event_id?: string) =>
  mutate(() => (event_id ? `/v2/activities/dashboard/register/detail/${event_id}` : false));

// 报名配置项-保存
export const saveRegisterConfig = (data: Partial<RegisterSaveParams>) => {
  const path = '/v2/activities/dashboard/register/save-config';
  return post(HttpPrefix.WEMEET_TAPI, path, data).then((res) => {
    if (res.code !== 0) return Promise.reject(res.msg || res.err_detail);
    return true;
  });
};
